import {
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	inject,
	input,
} from '@angular/core';

import { GoogleMapComponent } from '@valk-nx/components/ui-google-map/src/lib/google-map';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { HotelStore } from '@valk-nx/storyblok-store/src/lib/store/hotel/hotel.store';

type CoordinateInput = number | string | undefined;

@Component({
	selector: 'sb-map',
	templateUrl: './map.html',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [GoogleMapComponent, StoryblokDirective],
	host: { class: 'size-full' },
})
export class MapComponent extends StoryblokRootDirective {
	readonly hotelStore = inject(HotelStore);

	long = input<CoordinateInput>(undefined);
	lat = input<CoordinateInput>(undefined);

	longitude = computed(() => {
		const parsed = this.parseCoordinate(this.long());
		return parsed ?? this.hotelStore.address().longitude;
	});

	latitude = computed(() => {
		const parsed = this.parseCoordinate(this.lat());
		return parsed ?? this.hotelStore.address().latitude;
	});

	parseCoordinate(value: string | number | undefined): number | undefined {
		const num =
			typeof value === 'string' ? Number.parseFloat(value) : value;
		if (!num || Number.isNaN(num)) return undefined;
		return num;
	}
}
